import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  text: {
    [theme.breakpoints.up('md')]: {
      fontSize: '4rem',
    },
  }
}));

function ScoreboardScore({ score }) {
  const classes = useStyles();
  return (
    <Typography
      align="center"
      className={classes.text}
    >
      {score}
    </Typography> 
  )
}

export default ScoreboardScore;
